import { SeanceFormData } from 'src/screens/General/screens/Cases/screens/CaseCalendarScreen/components/EventForm';
import { ISeanceSend } from '../types/seance';
import moment from 'moment';

export const groupSeance = (dataForm: Partial<SeanceFormData>): Partial<ISeanceSend> => {
    const {
        startTime,
        seanceDate,
        endTime,
        isWeekly,
        serviceLocation,
        serviceType,
        minPerUnit,
        isHome,
        isInPerson,
        isTelehealth,
        isSchool,
        startTimeOld,
        endTimeOld,
        ...data
    } = dataForm;

    const dataSend: any = {
        ...data,
    };
    if (seanceDate) {
        dataSend.seanceDate = moment(seanceDate).format('YYYY-MM-DD');
    }
    if (startTime && seanceDate) {
        const hoursStart = +moment(startTime).format('HH');
        const minStart = +moment(startTime).format('mm');
        dataSend.startTime = moment(seanceDate)
            .set('hour', hoursStart)
            .set('minute', minStart)
            .set('second', 0)
            .format('YYYY-MM-DD HH:mm');
        let oldTimeStart = '';
        if (startTimeOld) {
            const hoursStartOld = +moment(startTimeOld).format('HH');
            const minStartOld = +moment(startTimeOld).format('mm');
            //const ssOld = +moment(startTimeOld).format('ss');

            oldTimeStart = moment(seanceDate)
                .set('hour', hoursStartOld)
                .set('minute', minStartOld)
                .format('YYYY-MM-DD HH:mm');
            if (dataSend.startTime === oldTimeStart) {
                dataSend.startTime = moment(dataSend.startTime, 'YYYY-MM-DD HH:mm')
                    //    .set('second', ssOld)
                    .format('YYYY-MM-DD HH:mm:ss');
            }
        }
    }
    if (serviceLocation) {
        dataSend.serviceLocation = serviceLocation.value;
    }
    if (serviceType) {
        dataSend.serviceType = serviceType.value;
    }

    if (!isWeekly) {
        dataSend.isWeekly = false;
    } else {
        dataSend.isWeekly = true;
    }
    if (minPerUnit && minPerUnit.value) {
        dataSend.minPerUnit = minPerUnit.value;
    } else {
        dataSend.minPerUnit = minPerUnit;
    }

    dataSend.isHome = isHome ? !!isHome : false;
    dataSend.isInPerson = isInPerson ? !!isInPerson : false;
    dataSend.isTelehealth = isTelehealth ? !!isTelehealth : false;
    dataSend.isSchool = isSchool ? !!isSchool : false;

    if (endTime && seanceDate) {
        const hoursEnd = +moment(endTime).format('HH');

        const minEnd = +moment(endTime).format('mm');
        dataSend.endTime = moment(seanceDate)
            .set('hour', hoursEnd)
            .set('minute', minEnd)
            .set('second', 0)
            .format('YYYY-MM-DD HH:mm:ss');

        let oldTimeEnd = '';
        if (startTimeOld) {
            const hoursStartOld = +moment(endTimeOld).format('HH');
            const minStartOld = +moment(endTimeOld).format('mm');
            // const ssOld = +moment(endTimeOld).format('ss');

            oldTimeEnd = moment(seanceDate)
                .set('hour', hoursStartOld)
                .set('minute', minStartOld)
                .format('YYYY-MM-DD HH:mm');

            if (dataSend.endTime === oldTimeEnd) {
                dataSend.endTime = moment(dataSend.endTime, 'YYYY-MM-DD HH:mm')
                    //       .set('second', ssOld)
                    .format('YYYY-MM-DD HH:mm:ss');
            }
        }

        //dataSend.endTime = moment(`${moment(seanceDate).format('L')}-${moment(endTime).format('LT')}`).format();
    }

    delete dataSend.providerId;
    delete dataSend.ColumnForm;

    return dataSend;
};
